import React from 'react';
import { Link } from "react-router-dom";
import './Home.css';
import './Details.css';

function Disclaimer() {
  return (
    <div>
        <h1 className="welcome">Welcome to the MSE Course Navigator</h1>
        <img className="picture" src="./Other/MSELogo.jpg" alt=""/>

        <div className="margin">
          <h2>Notes:</h2>
          <h3>1. The MSE navigator is based on the four-year curriculum. However, you may refer to the following page for the flexible program <a href = "https://www.sfu.ca/mechatronics/current-students/undergraduate-students/undergraduate-program-requirements/flex-ugrad-curriculum.html" target = "_blank" rel="noopener noreferrer">here</a></h3>
          <h3>2. You may need to adjust the zoom settings on your screen for optimal viewing</h3>
          <Link to="/Home" className="middle">Enter</Link>
        </div>
    </div>
  )
}
export default Disclaimer;